// Refresh хранится в localStorage чтобы пережить перезапуск браузера.
// Access НЕ хранится — короткий TTL, безопаснее держать в памяти.
// (см. WEB_UI_SPEC §4).

const REFRESH_KEY = 'podpipe.refresh'
// Кешируем is_admin чтобы не мигать меню при перезагрузке страницы.
// Фактическое значение всегда перезаписывается из JWT при первом refresh.
const IS_ADMIN_KEY = 'podpipe.is_admin'

export function loadRefresh(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY)
  } catch {
    return null
  }
}

export function saveRefresh(token: string): void {
  try {
    localStorage.setItem(REFRESH_KEY, token)
  } catch {
    // приватный режим — игнорируем
  }
}

export function clearRefresh(): void {
  try {
    localStorage.removeItem(REFRESH_KEY)
  } catch {
    // игнорируем
  }
}

export function loadIsAdmin(): boolean {
  try {
    return localStorage.getItem(IS_ADMIN_KEY) === 'true'
  } catch {
    return false
  }
}

export function saveIsAdmin(value: boolean): void {
  try {
    if (value) localStorage.setItem(IS_ADMIN_KEY, 'true')
    else localStorage.removeItem(IS_ADMIN_KEY)
  } catch {
    // игнорируем
  }
}

export function clearIsAdmin(): void {
  try {
    localStorage.removeItem(IS_ADMIN_KEY)
  } catch {
    // игнорируем
  }
}
